import { ARTICLE_STATUS } from "../components/NewsManagement/Articles/articleConstants";

export const SUPER_ADMIN_ROLE_NAME = "Super Admin";

// Article approval workflow
export const isSuperAdminRole = (roleName) =>
  String(roleName || "")
    .trim()
    .toLowerCase() === SUPER_ADMIN_ROLE_NAME.toLowerCase();

// Article approval workflow
export const forceDraftStatusOnFormData = (formData) => {
  const payload = new FormData();

  for (const [key, value] of formData.entries()) {
    if (key !== "Status" && key !== "status") {
      payload.append(key, value);
    }
  }

  payload.append("Status", ARTICLE_STATUS.DRAFT);
  payload.append("status", ARTICLE_STATUS.DRAFT);
  return payload;
};

// Article approval workflow
export const preserveStatusOnFormData = (formData, existingStatus) => {
  const payload = new FormData();
  const resolvedStatus = existingStatus || ARTICLE_STATUS.DRAFT;

  for (const [key, value] of formData.entries()) {
    if (key !== "Status" && key !== "status") {
      payload.append(key, value);
    }
  }

  payload.append("Status", resolvedStatus);
  payload.append("status", resolvedStatus);
  return payload;
};
